import React from 'react';

function Success({ success }) {
  return (
    <div className="notice notice--success">
      <p>
        <span className="notice__title">Success: </span>
        {success}
      </p>
    </div>
  );
}

export default Success;
